import { ManageCustomerServiceItemsQuery } from "#src/api/CustomerServiceItem.ts";
import { BorderCard } from "#src/components/items/BorderCard.tsx";
import ManageIcon from "#src/components/items/ManageIcon.tsx";
import { Link } from "#src/components/Router.tsx";
import { useApi } from "#src/stores/Api.tsx";
import { useStore } from "#src/stores/Store.tsx";
import formatMoney from "#src/utils/formatMoney.ts";
import tw from "#src/utils/tw.ts";
import { CustomerServiceItemType, StripeType } from "#types/code-generator.ts";
import { groupBy, uniqBy } from "es-toolkit";

export function BillingAlerts() {
  const store = useStore();

  const queryCustomerServiceItems = useApi(ManageCustomerServiceItemsQuery, {
    variables: {
      where: {
        organizationId: store.organization.id,
        unread: true,
        type: {
          in: [
            CustomerServiceItemType.OutstandingBalance,
            CustomerServiceItemType.NoPaymentInformation,
            CustomerServiceItemType.ExpiredCard,
          ],
        },
      },
    },
  });

  const customerServiceItems =
    queryCustomerServiceItems.customerServiceItems || [];

  if (!queryCustomerServiceItems.customerServiceItems) {
    return null;
  }

  const groupedCustomerServiceItems = groupBy(
    customerServiceItems,
    (i) => i?.user?.id
  );

  const unreadCustomerServiceItems = Object.keys(
    groupedCustomerServiceItems
  ).length;

  let outstandingBalanceItems = customerServiceItems.filter(
    (c) =>
      c.type === CustomerServiceItemType.OutstandingBalance ||
      c.type === CustomerServiceItemType.NoPaymentInformation
  );

  outstandingBalanceItems = uniqBy(outstandingBalanceItems, (i) => i.user?.id);

  const outstandingBalance = outstandingBalanceItems.reduce(
    (acc, c) => acc + Math.max(c.user?.balance, 0),
    0
  );

  return (
    <BorderCard className="overflow-hidden">
      <div>
        {store.organization.stripe !== StripeType.Adyen &&
          !store.organization.stripeAccountId &&
          !store.organization.stripeExpressAccountId && (
            <Link
              to="/admin/bank"
              className="bg-error -mx-4 -mt-4 mb-2 flex items-center gap-2 px-4 pt-2.5 pb-1.5 text-sm text-white"
            >
              <div className="flex h-5 w-5 items-center justify-center rounded-full bg-white">
                <i
                  aria-hidden
                  className="far fa-triangle-exclamation text-error"
                />
              </div>
              <div>
                Bank not connected. Tap here to start collecting payments.
              </div>
            </Link>
          )}
        <Link to="/admin/finance">
          <div className="flex">
            <ManageIcon error={unreadCustomerServiceItems > 0}>
              <i
                aria-hidden
                className={tw(
                  "far",
                  unreadCustomerServiceItems > 0
                    ? "fa-circle-exclamation text-error"
                    : "fa-file-chart-column"
                )}
              />
            </ManageIcon>
            <div className="flex-1 pl-4">
              <p className="mb-0">
                <strong>Finance</strong>
              </p>
              <p className="text-empty mb-0 text-sm">
                ${formatMoney(outstandingBalance)} due
                {unreadCustomerServiceItems === 0 && " • Woohoo!"}
                {unreadCustomerServiceItems > 0 && (
                  <>
                    {" "}
                    • {unreadCustomerServiceItems} account
                    {unreadCustomerServiceItems !== 1 && "s"}
                  </>
                )}
              </p>
            </div>
          </div>
        </Link>
      </div>
    </BorderCard>
  );
}
